// src/pages/PrivacyPolicy.jsx

import React from 'react';
import { Container, Box, Typography, Link, List, ListItem, ListItemText } from '@mui/material';

export default function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Last updated: {new Date().toLocaleDateString()}
        </Typography>
      </Box>

      <Typography variant="body1" sx={{ mb: 2 }}>
        Your privacy is important to us. This Privacy Policy explains how Meetin collects, uses, and safeguards your information in compliance with applicable laws including the EU General Data Protection Regulation (GDPR), the California Consumer Privacy Act as amended by the CPRA (CCPA/CPRA), and Israel’s Protection of Privacy Law (PPL).
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Information We Collect</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        We collect:
      </Typography>
      <List dense>
        <ListItem><ListItemText primary="Account data (e.g., name, email)" /></ListItem>
        <ListItem><ListItemText primary="Organization and booking data (e.g., rooms, schedules)" /></ListItem>
        <ListItem><ListItemText primary="Authentication data (password hashes, OAuth identifiers)" /></ListItem>
        <ListItem><ListItemText primary="Usage and device data (cookies, logs, IP address)" /></ListItem>
        <ListItem><ListItemText primary="Payment-related identifiers via processors (e.g., Stripe)" /></ListItem>
      </List>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>How We Use Information</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        We use your information to provide, secure, and improve the service; to authenticate users; to communicate service updates; to comply with law; and for billing where applicable.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Legal Bases (GDPR)</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Where GDPR applies, we process personal data on the following legal bases: performance of a contract, legitimate interests (e.g., service security and improvement), compliance with legal obligations, and consent where required (e.g., certain marketing communications).
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Your Rights (GDPR, CCPA/CPRA, Israel PPL)</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Depending on your location, you may have rights to access, correct, delete, port, or object to certain processing of your personal data. You can also request restriction of processing and withdraw consent where applicable. California residents may opt out of certain “sharing” or “selling” of personal information, where applicable. Israeli law grants rights to review and request correction.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>International Transfers</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        We may process data globally. Where required, we implement appropriate safeguards for cross-border transfers (e.g., Standard Contractual Clauses under GDPR).
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Data Retention and Security</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        We retain personal data only as long as necessary for the purposes described or as required by law. We use administrative, technical, and organizational measures designed to safeguard data.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Children’s Privacy</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Our services are not directed to children under the age required by applicable law (e.g., 13 in the US, 16 in some EU countries). We do not knowingly collect data from such users.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Contact and Complaints</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        For questions or to exercise your rights, contact us at <Link href="mailto:support@meet-in.io">support@meet-in.io</Link>. You may also lodge a complaint with your local data protection authority (e.g., EEA Data Protection Authority, the Israeli Privacy Protection Authority, or applicable US regulators).
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Contact</Typography>
      <Typography variant="body1">
        If you have questions, contact us at <Link href="mailto:support@meet-in.io">support@meet-in.io</Link>.
      </Typography>
    </Container>
  );
}


